import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios, { API, TOKEN_KEY, formatError } from "../../lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        localStorage.setItem(TOKEN_KEY, data.token);
        navigate("/admin", { replace: true, state: { user: data.user } });
      })
      .catch((err) => navigate("/admin", { replace: true, state: { error: formatError(err) } }));
  }, [location.hash, navigate]);

  return <div data-testid="auth-callback" className="min-h-screen" />;
};
